import { useEffect, useState } from 'react';
import { buildTodayBoard } from '../utils/todayBoard';

export function useTodayQueueCount(clinicId) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!clinicId) {
      setCount(0);
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const { aiConsentService } = await import('../services/aiConsentService');
        const { consentQaService } = await import('../services/consentQaService');
        const { reviewService } = await import('../modules/googleReviews');
        const [consents, threads, unreadReviews] = await Promise.all([
          aiConsentService.getClinicConsents(clinicId).catch(() => []),
          consentQaService.listClinicThreads(clinicId, { status: 'all', pageSize: 50 }).catch(() => []),
          reviewService.countUnreadFeedback(clinicId).catch(() => 0),
        ]);
        if (cancelled) return;
        const unreadMessages = (threads || []).filter((thread) => Number(thread.unreadByClinic || 0) > 0).length;
        const board = buildTodayBoard({
          consents: consents || [],
          unreadMessages,
          unreadReviews: unreadReviews || 0,
        });
        setCount(board.actionCount);
      } catch {
        if (!cancelled) setCount(0);
      }
    };

    load();
    window.addEventListener('consentDataChanged', load);
    return () => {
      cancelled = true;
      window.removeEventListener('consentDataChanged', load);
    };
  }, [clinicId]);

  return count;
}
